import classNames from 'classnames';
import * as React from 'react';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';
import * as IBooks from '../../../../interfaces/merchants/resources/books';
import BooksCheckInput, { InputType } from './BooksCheckInput';

import StringUtils from '../../../utils/StringUtils';
import css from './BooksOptionsList.module.scss';

interface Props extends React.HTMLProps<{}> {
  options: IBooks.Option[];
  checkedOptions: IBooks.Option[];
  onChange?: (e: React.ChangeEvent) => void;
}

const BooksOptionsList = ({
  className,
  intl,
  options,
  checkedOptions,
  onChange,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.BooksOptionsList, className);

  return (
    <ul className={classes}>
      {options.map(option => (
        <li key={option.id} className={css.BooksOptionsList__ListItem}>
          <BooksCheckInput
            type={InputType.Checkbox}
            name="options"
            value={option.id}
            checked={!!checkedOptions.find(o => o.id === option.id)}
            labelClassName={css.BooksOptionsList__Option}
            onChange={onChange}
          >
            <div className={css.BooksOptionsList__OptionInner}>
              <span className={css.BooksOptionsList__Name}>{option.name}</span>
              <span className={css.BooksOptionsList__Time}>
                (
                <FormattedMessage
                  id="books.optionsList.time"
                  values={{ time: intl.formatNumber(option.duration / 60) }}
                />
                )
              </span>
            </div>
            <span className={css.BooksOptionsList__Price}>
              <FormattedMessage
                id="books.optionsList.price"
                values={{ price: option.price }}
              />
            </span>
          </BooksCheckInput>
          {option.description && (
            <span className={css.BooksOptionsList__Description}>
              {StringUtils.nl2br(option.description)}
            </span>
          )}
        </li>
      ))}
    </ul>
  );
};

export default injectIntl(BooksOptionsList);
